export class OnboardingModel {
  businessName: string = "";
  branch: string = "";
  type: string = "";
  address: string = "";
  mobileNo: string = "";
  phoneNo: string = "";
  postalCode: string = "";
  countryId: string = "";
  statesId: string = "";
  statesName: string = "";
  alternateEmailId: string = "";
  dateOfJoining: string = "";
  corporateLogo: string = "";
  documentProofTradeLicense: string = "";
  documentProofEmirates: string = "";
  emailId: string = "";
  firstName: string = "";
  lastName: string = "";
  city: string = "";
  title: string = "";
  countryName: string = "";
  cityId: string = "";

  constructor(data?: Partial<OnboardingModel>) {
    if (data) {
      Object.assign(this, data); // Merge existing data safely
    }
  }
}
